import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { NoteEntity } from './note.entity';
import { ProcessDefinitionEntity } from './process-definition.entity';

@Index('process__note__fk__note__id_fk', ['fkNoteId'], {})
@Index(
	'process__note__fk_process_definition__id_fk',
	['fkProcessDefinitionId'],
	{},
)
@Entity('process__note')
export class ProcessNoteEntity extends BaseEntity {
	@Column('int', { name: '_fk_process_definition__id', unsigned: true })
	public fkProcessDefinitionId!: number;

	@Column('int', { name: 'object__id' })
	public objectId!: number;

	@Column('int', { name: 'object_record__id' })
	public objectRecordId!: number;

	@Column('int', { name: '_fk__note__id', unsigned: true })
	public fkNoteId!: number;

	@ManyToOne(
		() => ProcessDefinitionEntity,
		(processDefinition) => processDefinition.processNotes,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessDefinition!: ProcessDefinitionEntity;

	@ManyToOne(() => NoteEntity, (note) => note.processNotes, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__note__id', referencedColumnName: 'id' }])
	public fkNote!: NoteEntity;
}
